import { useAgent } from "contexts/v1/masterData/AgentContext";
import React, { useRef } from "react";
import Swal from "sweetalert2";
import printJS from "print-js";

const PrintSusuk = ({ booking, refetch, onSuccess }) => {
  const printRef = useRef();
  // console.log("PrintSusuk booking", booking);
  const { agents } = useAgent();

  // 🔹 Ambil data agent berdasarkan ID
  const getAgentById = (agentId) =>
    agents.data.find((a) => a.id === agentId) || null;
  const agent = getAgentById(booking.agent_id);

  // 🔹 Fungsi untuk mencetak
  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) {
      console.error("Print reference not found");
      return;
    }
    // langusng print tanpa swal
    printJS({
      printable: printContent.innerHTML,
      type: "raw-html",
      targetStyles: ["*"],
      onPrintDialogClose: () => {
        Swal.fire({
          title: "Printing",
          text: "Printing is being processed...",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      },
    });

    // Swal.fire({
    //   title: "Konfirmasi Cetak",
    //   text: "Apakah Anda yakin ingin mencetak struk?",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#3085d6",
    //   cancelButtonColor: "#d33",
    //   confirmButtonText: "Ya, Cetak!",
    //   cancelButtonText: "Batal",
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     try {
    //       printJS({
    //         printable: printContent.innerHTML,
    //         type: "raw-html",
    //         targetStyles: ["*"],
    //         onPrintDialogClose: () => {
    //           Swal.fire({
    //             title: "Sedang Mencetak",
    //             text: "Struk sedang diproses...",
    //             icon: "success",
    //             timer: 1500,
    //             showConfirmButton: false,
    //           });

    //           // 🔹 Panggil onSuccess setelah pencetakan berhasil
    //           if (onSuccess) {
    //             onSuccess();
    //           }

    //           // 🔹 Refetch data untuk memperbarui tampilan setelah cetak
    //           if (refetch) {
    //             refetch();
    //           }
    //         },
    //       });
    //     } catch (error) {
    //       console.error("PrintJS Error:", error);
    //       Swal.fire("Error", "Gagal mencetak struk", "error");
    //     }
    //   } else {
    //     Swal.fire("Dibatalkan", "Cetak struk dibatalkan.", "info");
    //   }
    // });
  };

  return (
    <div>
      {/* Tombol Cetak */}
      <button className="btn btn-info" onClick={handlePrint}>
        Print
      </button>
      {/* print json booking */}
      {/* <pre>{JSON.stringify(booking, null, 2)}</pre> */}
      <div
        ref={printRef}
        id={`print-content-${booking.id}`}
        style={{ display: "none" }}
      >
        {/* 🔹 Struk dengan Desain Tabel (Ala Kasir Indomaret) */}
        {/* <div ref={printRef} style={{ display: "none" }}> */}
        <style>
          {`
          @media print {
            body {
              font-family: Arial, sans-serif;
              width: 80mm;
              padding: 5px;
            }
            .receipt {
              text-align: center;
              width: 100%;
              font-size: 18px;
            }
            .border-dashed {
              border-top: 1px dashed #000;
              margin: 8px 0;
            }
            table {
              width: 100%;
              font-size: 16px;
              border-collapse: collapse;
            }
            td, th {
              padding: 4px 0;
              text-align: left;
            }
            .right {
              text-align: right;
            }
            .center {
              text-align: center;
            }
          }
          `}
        </style>

        {/* Logo */}
        <div className="receipt">
          <img src="/Kuber.jpeg" alt="Logo" style={{ width: "200px" }} />
          <p>
            <strong>KUBER BALI ADVENTURE</strong>
          </p>
          <p>Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572</p>
          <div className="border-dashed"></div>
        </div>

        {/* Detail Booking */}
        <table>
          <tbody>
            <tr>
              <td>
                <strong>Code</strong>
              </td>
              <td className="right">{booking.code}</td>
            </tr>
            <tr>
              <td>
                <strong>Date</strong>
              </td>
              <td className="right">{booking.reservation_date}</td>
            </tr>
            <tr>
              <td>
                <strong>Guest</strong>
              </td>
              <td className="right">{booking.guest_name}</td>
            </tr>
            <tr>
              <td>
                <strong>Hotel</strong>
              </td>
              <td className="right">{booking.guest_nationality || "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>Agent</strong>
              </td>
              <td className="right">{agent?.name || "-"}</td>
            </tr>
            <tr>
              <td>
                <strong>Driver</strong>
              </td>
              <td className="right">
                {/* {booking.driver_name || "-"} */}
                {booking.driver || "-"}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="border-dashed"></div>

        {/* Detail Produk */}
        <table>
          <thead>
            <tr>
              <th>Activity</th>
              <th className="right">Qty</th>
            </tr>
          </thead>
          <tbody>
            {/* {booking.activities.map((activity, index) => (
              <tr key={index}>
                <td>{activity.activity}</td>
                <td className="right">{activity.qty}</td>
              </tr>
            ))} */}
            {booking.activities
              .filter((activity) => parseInt(activity.include_susuk) === 1) // Hanya yang include_susuk = 1
              .map((activity, index) => (
                <tr key={index}>
                  <td>{activity.activity}</td>
                  <td className="right">{parseInt(activity.qty) || 0}</td>
                </tr>
              ))}
          </tbody>
        </table>

        <div className="border-dashed"></div>

        {/* Detail Pembayaran */}
        <table>
          <tbody>
            <tr>
              <td>
                <strong>Total Susuk</strong>
              </td>
              {/* <td className="right">Rp. {parseInt(booking.susuk_agent).toLocaleString("id-ID")}</td> */}
              <td className="right">
                Rp.
                {parseInt(booking.total_price_by_include_susuk).toLocaleString(
                  "id-ID"
                )}{" "}
                <br />- Rp.
                {parseInt(booking.net_price_by_include_susuk).toLocaleString(
                  "id-ID"
                )}{" "}
                <br />= Rp.{" "}
                {parseInt(booking.susuk_agent).toLocaleString("id-ID")}
              </td>
            </tr>
            <tr>
              {/* notesusuk */}
              <td>
                <strong>Note:</strong>
              </td>
              <td className="right">{booking.note_susuk || "-"}</td>
            </tr>
          </tbody>
        </table>

        <div className="border-dashed"></div>

        {/* Footer */}
        <div className="receipt">
          <p
            style={{ fontSize: "14px", textAlign: "center", margin: "10px 0" }}
          >
            Please review your transaction details before leaving the counter.
            <br />
            Once the transaction is completed, cancellations or refunds cannot
            be processed.
            <br />
            Thank you for your kind understanding.
          </p>
          <p>
            <strong>Powered by Kuber Bali Adventure</strong>
          </p>
          <p>
            <strong>www.kuberbaliadventure.com</strong>
          </p>
          <p>
            <strong>+6285183037017</strong>
          </p>
        </div>
        <div className="border-dashed"></div>
      </div>
    </div>
  );
};

export default PrintSusuk;
